import { useEffect, useState } from "react";

const Q = "(orientation: portrait)";

// Live orientation flag — re-renders the stage the moment a phone rotates.
export default function useOrientation() {
  const [portrait, setPortrait] = useState(() => (typeof window !== "undefined" ? window.matchMedia(Q).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(Q);
    const on = (e) => setPortrait(e.matches);
    mq.addEventListener ? mq.addEventListener("change", on) : mq.addListener(on);
    const onResize = () => setPortrait(window.innerHeight > window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", on) : mq.removeListener(on);
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return portrait;
}
